__turbopack_context__.v({
  "EmbedSection": "EmbedSection-module-scss-module__F7D97a__EmbedSection",
});
